import {FC} from 'react'

import {useServiceCommonContent} from '@/content/service-request/common'
import {Link, useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {QuestionsAndAnswersRelatedQuestion} from '@/utils/questions-and-answers/types'
import {routeTo} from '@/utils/router'

import {Text, TextFontWeight, TextVariant} from '../common/content/Text'
import {TitleBesideContentLayout} from '../common/content/TitleBesideContentLayout'
import {ArrowIcon} from '../common/icons/ArrowIcon'

type ServiceRequestFaqsProps = {
  // Resolved on the server - looking the ids up here would pull the multi-megabyte Q&A dataset
  // into the client bundle of every page rendering this component.
  relatedQuestions: QuestionsAndAnswersRelatedQuestion[]
}

export const ServiceRequestFaqs: FC<React.PropsWithChildren<ServiceRequestFaqsProps>> = ({
  relatedQuestions,
}) => {
  const {t} = useTranslation()
  const {title} = useServiceCommonContent().faqs

  return (
    <>
      <TitleBesideContentLayout title={t(title)}>
        <ul className="list">
          {relatedQuestions.map(({name, slug, categorySlug}) => (
            <li key={slug} className="item">
              <Link href={routeTo.trademarkQA.question(categorySlug, slug)} legacyBehavior>
                <a className="wrapper" target="_blank">
                  <Text variant={TextVariant.h6} element="p" fontWeight={TextFontWeight.bold}>
                    {name}
                  </Text>
                  <div className="icon">
                    <ArrowIcon color={theme.palette.text.default} />
                  </div>
                </a>
              </Link>
            </li>
          ))}
        </ul>
      </TitleBesideContentLayout>

      <style jsx>{`
        .item {
          border-top: 1px solid ${theme.palette.gray[100]};
        }
        .item:last-of-type {
          border-bottom: 1px solid ${theme.palette.gray[100]};
        }
        .wrapper {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: ${theme.spacing[3.5]} 0;
        }
        .icon {
          margin-left: ${theme.spacing[5]};
        }
      `}</style>
    </>
  )
}
